/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeliveryInfoDto } from './deliveryInfoDto';


export interface DeliveryInfoNotificationDto { 
    /**
     * the unique ID of your previously well sent SMS that you will have to use to correlate the corresponding SMS
     */
    callbackData: string;
    /**
     * Détail des informations de livraison du sms
     */
    deliveryInfo: DeliveryInfoDto | null;
}

